module.exports = __webpack_public_path__ + "media/images/categories/color/flats-fcd06f140a1120e585a9c02f8e73a3e0.png";